import { render, staticRenderFns } from "./telkom.vue?vue&type=template&id=65c2e932"
import script from "./telkom.vue?vue&type=script&lang=js"
export * from "./telkom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports